import { render, staticRenderFns } from "./IconBellFilled.vue?vue&type=template&id=034edc40&scoped=true"
import script from "./IconBellFilled.vue?vue&type=script&lang=js"
export * from "./IconBellFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034edc40",
  null
  
)

export default component.exports